<template>
     <div class="entity-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Partner" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="entity-id" type="hidden" v-model="entity.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group label="Name:" label-for="entity-name_entity">
                        <b-form-input id="entity-name_entity" type="text" ref="searchFocus"
                            v-model="entity.name_entity" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>   
                <!--b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="entity.physical_person" true-value="1" false-value="0" 
                                type="checkbox" 
                                id="entity-physical_person"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="entity-physical_person">
                                Pessoa Física?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">    
                        <b-form-input v-if="entity.physical_person" v-mask="['###.###.###-##']" id="entity-cnpj_cpf" type="text"
                            v-model="entity.cnpj_cpf" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="CPF..." />
                        <b-form-input v-else v-mask="['##.###.###/####-##']" id="entity-cnpj_cpf" type="text"
                            v-model="entity.cnpj_cpf" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="CNPJ..." />    
                    </b-form-group>
                </b-col-->
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="entity.blocked" true-value="1" false-value="0" 
                                type="checkbox" 
                                id="entity-blocked"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="entity-blocked">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
            <!--b-card no-body>
                    <b-tabs card vertical >
                        <b-tab title="Registro" active>
                        <b-form>
                             <b-row>
                                <b-col md="3" sm="12">
                                    <b-form-group label="Inscrição Estadual:" label-for="entity-insc_state">
                                        <b-form-input id="entity-insc_state" type="text"
                                            v-model="entity.insc_state" 
                                              size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Incrição Estadual" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group label="Inscrição Municipal:" label-for="entity-insc_municipal">
                                        <b-form-input id="entity-insc_municipal" type="text"
                                            v-model="entity.insc_municipal" 
                                              size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Incrição Municipal" />
                                    </b-form-group>
                                </b-col>
                                 <b-col md="3" sm="12">
                                    <b-form-group label="Junta Comercial:" label-for="entity-insc_joint">
                                        <b-form-input id="entity-insc_joint" type="text"
                                            v-model="entity.insc_joint" 
                                              size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Incrição na Junta Comercial" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4" sm="12">
                                <b-form-group label="Nome Fantasia:" label-for="entity-fantasy_name">
                                    <b-form-input id="entity-fantasy_name" type="text"
                                        v-model="entity.fantasy_name" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Nome Fantasia" />
                                </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Grupo:" label-for="entity-group_entity_id">
                                        <b-form-select id="entity-group_entity_id"
                                          size="sm"
                                        
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="groupentitys" v-model="entity.group_entity_id" />
                                    </b-form-group>
                                    
                                </b-col>
                            </b-row>
                        </b-form>

                    </b-tab >
                    <b-tab title="Endereço" >
                        <b-form>
                            <b-row>
                                 <b-col md="2" sm="12">
                                    <b-form-group 
                                    label="CEP:" 
                                    label-for="entity-zip_code">
                                    <b-form-input v-mask="['#####-###']" 
                                    id="entity-zip_code" type="text"
                                    v-model="entity.zip_code" 
                                      size="sm"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    placeholder="CEP" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="1" sm="12">
                                  <b-link 
                                  @click="searchCep" 
                                  :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                  class="fa fa-search mt-4" 
                                  ></b-link > 
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6" sm="12">
                                    <b-form-group label="Endereço:" label-for="entity-adress">
                                        <b-form-input id="entity-adress" type="text"
                                        v-model="entity.adress" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Endereço..." />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group label="Complemento:" label-for="entity-complement">
                                        <b-form-input id="entity-complement" type="text"
                                        v-model="entity.complement" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Complemento..." />
                                    </b-form-group>
                                </b-col>
                                <b-col md="2" sm="12">
                                    <b-form-group 
                                        label="Número:" 
                                        label-for="entity-number">
                                        <b-form-input 
                                        id="entity-number" type="text"
                                         v-model="entity.number" 
                                         ref="inputnumber"
                                        size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder=" Número..." />
                                    </b-form-group>
                                </b-col>
                            </b-row>   
                            <b-row>
                                <b-col md="4" sm="12">
                                    <b-form-group label="Bairro:" label-for="entity-neighborhood">
                                        <b-form-input id="entity-neighborhood" type="text"
                                        v-model="entity.neighborhood" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Bairro" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="2" sm="12">
                                    <b-form-group 
                                        label="Estado:" label-for="entity-state_id">
                                        <b-select id="entity-state_id"
                                          size="sm"
                                        @input="loadCitys"
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="states" v-model="entity.state_id" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Cidade:" label-for="entity-city_id">
                                        <b-form-select id="entity-city_id"
                                          size="sm"
                                        
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="citys" v-model="entity.city_id" />
                                    </b-form-group>
                                    
                                </b-col>
                               
                            </b-row>
                        </b-form>    
                    </b-tab>
                    <b-tab title="Contato">
                        <b-form>
                            <b-row>
                                 <b-col md="5" sm="12">
                                    <b-form-group label="E-mail:" label-for="entity-email">
                                        <b-form-input id="entity-email" type="text"
                                        v-model="entity.email" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="E-mail" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group label="Telefone:" label-for="entity-telephone">
                                        <b-form-input id="entity-telephone" type="text"
                                        v-model="entity.telephone" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Telefone" />
                                    </b-form-group>
                                </b-col>
                                 <b-col md="3" sm="12">
                                    <b-form-group label="Celular:" label-for="entity-cellphone">
                                        <b-form-input id="entity-cellphone" type="text"
                                        v-model="entity.cellphone" 
                                          size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="Telefone" />
                                    </b-form-group>
                                </b-col>   
                            </b-row>
                            <b-row>
                                <b-col md="6" sm="12">
                                    <b-form-group label="Imagem da Cliente/Fornecedor:" label-for="entity-photo">
                                        <b-form-file v-model="entity.photo" id="entity-photo" class="mt-3" accept=".jpg, .png, .gif" ></b-form-file>
                                    </b-form-group>
                                </b-col> 
                            </b-row>     
                        </b-form>
                        </b-tab>
                    </b-tabs>
                </b-card-->
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[getentitys(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
           <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            ref="searchFocus"
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by Partner name..." 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button  
                        title = "Detail" 
                        size="sm" 
                        variant="light" 
                        @click="loadentity(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadentity(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadentity(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>   
                <!--template v-slot:cell(accesses)="data">
                    <b-button  
                        title = "Acesso a Movimentação Financeira " 
                        size="sm" 
                        variant="light" 
                        @click="actionEntityReceipt(data.item)" 
                        class="mr-2 mt-2">
                            <i class="fa fa-external-link"></i>
                    </b-button>
                 </template--> 
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
             
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import {mask} from 'vue-the-mask'

export default {
    name: 'EntitySearch',
    directives: {mask},
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                groupentity: {},
                entity: {},
                return_cep: {},
                state:{},
                city:{},
                entitys: [],
                states: [],
                citys: [],
                groupentitys: [],
                perPage: 20,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'name_entity', label: 'Name', sortable: true,variant: 'light' },
            //    { key: 'fantasy_name', label: 'Nome Fantasia', sortable: true ,variant: 'light'},
                { key: 'cnpj_cpf', label: 'ID', sortable: false, variant: 'primary' },
            //    { key: 'email', label: 'E-mail', sortable: false ,variant: 'light'},   
            //    { key: 'name_group_entity', label: 'Grupo', sortable: true,variant: 'light' },   
            //    { key: 'telephone', label: 'Tel.Comercial', sortable: false ,variant: 'light'},   
            //    { key: 'cellphone', label: 'Tel.Celular', sortable: false ,variant: 'light'},   
                { key: 'blocked', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' ,variant: 'light'},               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
            ]
            }
        },
        computed: {
            filteredList() {
                return this.entitys.filter(entity => {
                    return entity.name_entity.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.entitys.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            goback(){
                 this.$router.go(-1, {query: 'q=s', hash: 'hashFrag'})
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            getgroupentity(){
                const url = `${baseApiUrl}/groupentitys/${this.groupentity.id}`
                axios(url).then(res=> {
                            this.groupentitys = res.data.map(groupentity => {
                                return { value: groupentity.id, text: !groupentity.synthetic ? ' => ' + groupentity.name : groupentity.name, disabled: groupentity.synthetic ? true: false }
                            })
                        })
            },
            getentitys(){
                const url = `${baseApiUrl}/entitysbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.entitys = res.data
                      this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.entity = {}
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.getentitys()
                this.entity = {}
            },
            async save() {

                if(!this.entity.group_entity_id){

                    this.entity.group_entity_id = this.groupentity.id
                }
                this.entity.type_entity_id = 1
                this.entity.company_id = this.compan.id
                const method = this.entity.id ? 'put' : 'post'
                const id = this.entity.id ? `/${this.entity.id}` : ''
                await axios[method](`${baseApiUrl}/entitys${id}`, this.entity)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.entity.id
                    axios.delete(`${baseApiUrl}/entitys/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadStates() {
                const url = `${baseApiUrl}/states`
                axios.get(url).then(res => {
                    this.states = res.data.map(state => {
                        return { value: state.id, text: state.initials }
                    })
                })
            },
            loadCitys() {
                    let id = this.entity.state_id
                    if(id){
                        const url = `${baseApiUrl}/citys/${id}`
                        axios.get(url).then(res => {
                            this.citys = res.data.map(city => {
                                return { value: city.id, text: city.name }
                            })
                        })
                    }
                  
            },
            loadentity(entity, mode = 'save') {
                this.mode = mode
                this.entity = { ...entity }
                this.$refs.searchFocus.focus();
            },
            actionEntityReceipt(entity) {      
                 if(!this.compan)
                {
                    this.$toasted.global.defaultError({msg:'Logar na Empresa'})
                }else{

                     this.$router.push({
                        name: 'CreditClientReceipt',    
                        params: {id: entity.id}
                    })

                }              
            },
            loadGroupEntitys() {
                const url = `${baseApiUrl}/groupentitys`
                axios.get(url).then(res => {
                    this.groupentitys = res.data.map(groupentity => {
                        return { value: groupentity.id, text: !groupentity.synthetic ? ' => ' + groupentity.name : groupentity.name, disabled: groupentity.synthetic ? true: false }
                    })
                })
            },
            searchCep() {
                    if(this.entity.zip_code)
                    {
                    const zip_code = this.entity.zip_code
                    delete axios.defaults.headers.common["Authorization"]
                        axios
                        .get(`https://viacep.com.br/ws/${ zip_code.replace('-','') }/json/`)
                        .then(res => {
                                this.entity.adress = res.data.logradouro
                                this.entity.neighborhood = res.data.bairro
                                this.zip_code = res.data.cep
                                this.return_cep = res.data
                                this.setState()
                                this.$refs.inputnumber.focus()
                        })
                        .catch(showError)
                        
                    } 
                },
                 setState(){

                    const urlstate = `${baseApiUrl}/statesby/?initials=${this.return_cep.uf}`
                    axios.defaults.headers.common['Authorization'] = `bearer ${this.user.token}`
                    axios(urlstate).then(
                            res=> {this.state = res.data
                                    this.setCity()
                            }  
                    )
                },
                 setCity(){

                    const urlcity = `${baseApiUrl}/citysby/${this.return_cep.ibge}`
                    axios.defaults.headers.common['Authorization'] = `bearer ${this.user.token}`
                    axios(urlcity).then(res=> {
                        this.city = res.data
                        this.setCompl() 
                    })
                },
             setCompl(){
                            
                    this.entity.state_id = this.state[0].id
                    this.entity.city_id = this.city[0].id

                    this.entity = {...this.entity}   
                },
        },
        watch:{
            $route(to){
                this.groupentity.id = to.params.id
                this.entitys = []
               // this.getgroupentity()
                this.getentitys()
            }
        },
        mounted(){
           // this.getgroupentity()
            this.getentitys()
           // this.loadStates()
           // this.loadGroupEntitys()
            this.showTable = true
        }
}
</script>

<style>

    .sub-background{
        background:linear-gradient(to top, #bdc3c7, #e7ebee)
    }
    .entity-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .entity-search button{
        font-size: 0.75rem;
    }

     .entity-search select{
        font-size: 0.75rem;
    }

    .entity-search input{
        font-size: 0.75rem;
    }

    #modalGroupEntity {
        font-size: 0.75rem;
    }

    #modalGroupEntity button{
        font-size: 0.75rem;
    }

     #modalGroupEntity select{
        font-size: 0.75rem;
    }

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
